import { HOTJAR_ENABLED } from './analytics/hotjar';
import { HeaderFooterLayout } from './app';

/** A bare, diagnostic page showing some env vars used to confirm the site is up & some relevant (client-friendly) env vars */
const Healthcheck = () => {
  return (
    <HeaderFooterLayout>
      <div className='flex flex-col m-10'>
        <p>Environment: {import.meta.env.VITE_ENVIRONMENT}</p>
        <p>App version: {import.meta.env.VITE_APP_VERSION}</p>
        <p>Analytics Enabled: {import.meta.env.VITE_ANALYTICS_ENABLED}</p>
        <p>Hotjar Enabled: {HOTJAR_ENABLED}</p>
        <p>API: {import.meta.env.VITE_API_HOST}</p>
      </div>
    </HeaderFooterLayout>
  );
};

export default Healthcheck;
